import mixpanel from 'mixpanel-browser';
// process.env.VUE_APP_MIXPANEL_TOKEN
mixpanel.init('3f3c394d754f5d1ba198f736126683e2', {
    debug: process.env.VUE_APP_NODE_ENV == 'production' ? false : true,  // Turned off in production
    track_pageview: true,
    persistence: "localStorage",
});

export default mixpanel;
